export default __webpack_public_path__ + "static/media/ODBIERZ_ZETON.ae1e4c9f.png";